<template>
  <div
    :id="`vendor-assessment-text-area-heading-${checklistItemDataRaw.checklistItemId}`"
    :class="`tw-flex tw-flex-col tw-border-0 tw-border-b tw-border-solid tw-border-[#EFF0F1] tw-rounded-t-[6px] assessmentQuestion tw-text-[#231F20] tw-text-base tw-font-[Poppins]`"
    @mouseover="onHoverIn"
    @mouseout="onHoverOut"
  >
    <div
      :class="`tw-w-full tw-p-[15px] md:tw-p-[25px] question ${
        isSelected ? 'tw-bg-[rgba(242,248,255,0.5)]' : ''
      }`"
    >
      <div class="tw-grid tw-grid-cols-5 gap-3">
        <div class="tw-col-span-5 md:tw-col-span-3 xl:tw-col-span-4">
          <div class="tw-flex tw-gap-[15px] tw-w-full">
            <div
              :class="`tw-flex tw-items-center tw-justify-start tw-gap-[15px] tw-h-[fit-content] tw-mt-[2px]`"
            >
              <ToggleIcon
                :id="`vendor-assessment-text-area-radio-heading-${checklistItemDataRaw.checklistItemId}`"
                :class="`${
                  isExclude || checklistItemDataRaw.checklistItemIsNa
                    ? `tw-opacity-50`
                    : 'tw-cursor-pointer'
                }`"
                :ticked="isSelected"
                color="#387dff"
                @click="handleSelectedQuestions"
              />
            </div>
            <div
              :class="`tw-flex tw-flex-col tw-gap-[20px] tw-w-full questionWrapper`"
            >
              <div
                v-if="
                  checklistItemDataRaw?.visibleState ===
                  assessmentQuestionVisibleState.prefilled
                "
                class="prefilled"
              >
                <AssessmentQuestionPrefilledTag
                  :number-question="''"
                  color="green"
                  :expand="!isCollapsed"
                />
              </div>
              <div class="tw-flex tw-justify-between tw-items-center">
                <div class="tw-flex tw-gap-[15px]">
                  <div
                    class="tw-flex tw-items-center tw-gap-[10px] tw-text-[#231F20] tw-text-[16px] tw-not-italic tw-font-normal tw-leading-[normal]"
                  >
                    <p
                      :class="`text-with-icon ${
                        isExclude || checklistItemDataRaw.checklistItemIsNa
                          ? `greyed`
                          : ''
                      }`"
                    >
                      <slot name="default">
                        <span
                          class="tw-text-[#231F20] tw-text-base tw-font-[Poppins]"
                          data-cy="question-name"
                          :data-id="`${checklistItemDataRaw.checklistItemId}`"
                        >
                          {{
                            checklistItemDataRaw.checklistItemHeadingLabel ||
                            checklistItemDataRaw.checklistItemName
                          }}
                          {{
                            checklistItemDataRaw.subName
                              ? ` | ${checklistItemDataRaw.subName}`
                              : ""
                          }}
                        </span>
                      </slot>
                      <span
                        v-if="
                          (checklistItemDataRaw.checklistItemDescription ||
                            checklistItemDataRaw.checklistItemGuidance) &&
                          onHover
                        "
                        class="info-icon tw-ml-[15px] md:tw-ml-[25px]"
                      >
                        <ButtonShowDuplicateAssessment
                          :id-popover="'popover' + Math.random() * 1000"
                          :custom-class="'tw-w-[max-content] tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
                          :class="`!tw-p-0 tw-leading-[16px]`"
                          :classes="`!tw-leading-none tw-flex tw-items-center tw-justify-center`"
                        >
                          <div class="tw-p-[15px] tw-w-[475px]">
                            <div
                              class="tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]"
                            >
                              <div
                                v-if="
                                  checklistItemDataRaw.checklistItemDescription
                                "
                              >
                                <div
                                  class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                                >
                                  {{
                                    getComponentUiText(
                                      "app-menu-submenu-assessments-further-information-1",
                                    )
                                  }}
                                </div>
                                <CustomDescriptionContent
                                  :description="
                                    checklistItemDataRaw.checklistItemDescription
                                  "
                                  :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                                >
                                </CustomDescriptionContent>
                              </div>
                              <div
                                v-if="
                                  checklistItemDataRaw.checklistItemGuidance
                                "
                              >
                                <div
                                  class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                                >
                                  {{
                                    getComponentUiText(
                                      "app-menu-submenu-assessments-guidance-1",
                                    )
                                  }}
                                </div>
                                <CustomDescriptionContent
                                  :description="
                                    checklistItemDataRaw.checklistItemGuidance
                                  "
                                  :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                                >
                                </CustomDescriptionContent>
                              </div>
                            </div>
                          </div>
                        </ButtonShowDuplicateAssessment>
                      </span>
                    </p>
                    <div
                      v-if="checklistItemDataRaw.checklistItemIsNa"
                      class="prefilled"
                    >
                      <AssessmentQuestionNotApplicableTag
                        color="grey"
                        :expand="!isCollapsed"
                      />
                    </div>
                    <StatusBadge
                      v-if="evaluateAnswer"
                      class="tw-w-fit"
                      :data-cy="`status-badge-lable-${checklistItemDataRaw.checklistItemId}`"
                      :lable-class="`tw-max-w-fit`"
                      :label="getLabelEvaluateTag() ?? ''"
                      :value="getValueEvaluateTag() ?? ''"
                    />
                  </div>
                </div>
              </div>
              <div
                :id="`vendor-assessment-text-area-editor-${checklistItemDataRaw.checklistItemId}`"
                :class="`tw-max-w-[94%] md:tw-max-w-[95%] lg:tw-max-w-[965px] ${
                  checklistItemDataRaw.checklistItemIsNa
                    ? 'tw-pointer-events-none'
                    : ''
                }`"
              >
                <WYSiwygEditor
                  v-model="notesValue"
                  :include-image="false"
                  :is-disabled="isChecklistCompleted"
                  :custom-class="`xl:tw-max-w-[calc(100%-130px)] 2xl:tw-max-w-[calc(100%-50px)]`"
                  @update:blur="handleFocusoutUpdateNote"
                  @update:value="($event) => handleUpdateNote($event)"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="tw-col-span-5 md:tw-col-span-2 xl:tw-col-span-1">
          <div
            class="tw-flex tw-items-center tw-justify-end tw tw-w-[100%] tw-h-full tw-gap-[20px]"
          >
            <span
              v-if="
                checklistItemDataRaw?.visibleState ===
                  assessmentQuestionVisibleState.prefilled &&
                !checklistItemDataRaw.checklistItemIsNa
              "
              class="tw-cursor-pointer tw-absolute md:tw-relative md:tw-top-[unset] tw-top-[22px] tw-right-[18px] arrow"
              @click="isCollapsed = !isCollapsed"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="8"
                viewBox="0 0 12 8"
                fill="none"
                :style="isCollapsed ? 'transform: rotate(180deg)' : ''"
              >
                <path
                  d="M11.8741 6.38894L6.38429 0.165448C6.33485 0.113191 6.27527 0.0715663 6.2092 0.0431191C6.14312 0.0146718 6.07194 -2.59124e-07 6 -2.62268e-07C5.92806 -2.65413e-07 5.85688 0.0146718 5.7908 0.0431191C5.72473 0.0715663 5.66515 0.113191 5.61571 0.165448L0.125859 6.38894C0.081969 6.43838 0.0483386 6.49604 0.02692 6.55858C0.00550146 6.62113 -0.00327902 6.6873 0.00108975 6.75327C0.0065009 6.81976 0.0251891 6.8845 0.056049 6.94364C0.086909 7.00279 0.129313 7.05515 0.180757 7.09763L1.10405 7.8712C1.15449 7.91483 1.21315 7.9479 1.27658 7.96848C1.34002 7.98905 1.40693 7.9967 1.47337 7.99098C1.53949 7.9862 1.604 7.96828 1.66313 7.93829C1.72225 7.9083 1.77481 7.86683 1.81773 7.8163L5.91516 3.10002C5.94039 3.07503 5.97447 3.06101 6.00998 3.06101C6.04549 3.06101 6.07957 3.07503 6.10481 3.10002L10.1823 7.8163C10.2629 7.91267 10.377 7.97505 10.5017 7.99098C10.5678 7.99738 10.6345 7.99052 10.6979 7.97081C10.7613 7.9511 10.8202 7.91893 10.871 7.87619L11.8192 7.09763C11.8707 7.05515 11.9131 7.00279 11.9439 6.94364C11.9748 6.8845 11.9935 6.81976 11.9989 6.75327C12.0033 6.6873 11.9945 6.62113 11.9731 6.55859C11.9517 6.49604 11.918 6.43838 11.8741 6.38894Z"
                  fill="#DBDBDB"
                />
              </svg>
            </span>

            <div
              v-if="
                !(
                  checklistItemDataRaw?.visibleState ===
                  assessmentQuestionVisibleState.prefilled
                ) || !isCollapsed
              "
              :class="`tw-flex tw-items-center tw-justify-end tw tw-w-[100%] tw-gap-[20px]`"
            >
              <div
                v-if="!isExclude && onHover"
                class="tw-flex tw-items-center tw-gap-[20px] others"
              >
                <ExpandingButton
                  :id="`vendor-assessment-text-area-btn-note-${checklistItemDataRaw.checklistItemId}`"
                  color="#387DFF"
                  :icon="PenIcon"
                  :text="
                    getComponentUiText(
                      'app-component-assessments-override-question-note-title-1',
                    )
                  "
                  @click="showAdvanceModal"
                />
                <ExpandingButton
                  :id="`vendor-assessment-text-area-btn-evidence-${checklistItemDataRaw.checklistItemId}`"
                  :class="
                    isChecklistCompleted &&
                    checklistItemDataRaw.checklistItemAttachments?.length === 0
                      ? '!tw-transform-none'
                      : ''
                  "
                  :color="
                    isChecklistCompleted &&
                    checklistItemDataRaw.checklistItemAttachments?.length === 0
                      ? '#62a2f5'
                      : '#387DFF'
                  "
                  :icon="PinIcon"
                  :text="
                    getComponentUiText(
                      'app-component-assessments-evidence-button-title-1',
                    )
                  "
                  max-width="95px"
                  @click="showAdvanceModal"
                />
                <div>
                  <ButtonShowMore
                    :id-popover="`vendor-assessment-text-area-btn-popover-${checklistItemDataRaw.checklistItemId}`"
                    :classes="`!tw-p-[0px]`"
                  >
                    <CustomDropDownItem
                      v-if="viewStyle !== TYPE_ASSESSMENT_VIEW_STYLE.vendor"
                      :style="`tw-self-center ${
                        isChecklistCompleted
                          ? '!tw-cursor-not-allowed normal'
                          : 'normal'
                      }`"
                      :id-text="'app-component-vendor-question-advance-option-1'"
                      :style-text="'!tw-self-auto'"
                      @click="showAdvanceModal"
                    />
                  </ButtonShowMore>
                </div>
              </div>
              <div
                v-if="
                  checklistItemDataRaw.itemCompleteValue !== undefined ||
                  isExclude
                "
                class="tw-flex tw-gap-[20px]"
              >
                <CircularProgressPercent
                  v-if="checklistItemDataRaw.itemCompleteValue !== undefined"
                  :id="`vendor-assessment-text-area-circular-percent-${checklistItemDataRaw.checklistItemId}`"
                  :data-cy="`circular-percent-${checklistItemDataRaw.checklistItemId}`"
                  :percent="checklistItemDataRaw.itemCompleteValue"
                  :compensating-override-score="
                    checklistItemDataRaw.checklistItemCompensatingControlValue
                  "
                  :compliance-override-score="
                    checklistItemDataRaw.checklistItemComplianceOverride
                  "
                  :class="'tw-cursor-pointer'"
                  :excluded="isExclude"
                  :size="44"
                  :text-size="11"
                />
                <Button4
                  v-if="isExclude"
                  :id="`vendor-assessment-text-area-circular-percent-${checklistItemDataRaw.checklistItemId}`"
                  :class="`tw-self-center ${
                    isChecklistCompleted ? '!tw-cursor-not-allowed' : ''
                  }`"
                >
                  {{
                    getComponentUiText("app-component-assessments-include-1")
                  }}
                </Button4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <VendorAssessmentQuestionEvaluate
        :id="`vendor-assess-review-question-evaluate-text-area-${checklistItemDataRaw.checklistItemId}`"
        :id-question="`${checklistItemDataRaw.checklistItemId}`"
        class="tw-mx-0"
        :checklist-item-data-raw="checklistItemDataRaw"
        :is-checklist-completed="isChecklistCompleted"
        :id-dropdown="`vendor-assess-review-question-evaluate-dropdown-${checklistItemDataRaw.checklistItemId}`"
        :id-note-input="`vendor-assess-review-question-evaluate-note-input-${checklistItemDataRaw.checklistItemId}`"
        :id-percent-input="`vendor-assess-review-question-evaluate-percent-input-${checklistItemDataRaw.checklistItemId}`"
        :background-input="`white`"
        :is-show-label="false"
        @update:evaluate-answer="handleSelectedEvaluateAnswer"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  Ref,
  ref,
  computed,
  PropType,
  ComputedRef,
  onMounted,
  watch,
} from "vue";
import ToggleIcon from "../svgs/toggleIcon.vue";
import {
  TYPE_ASSESSMENT_VIEW_STYLE,
  assessmentQuestionVisibleState,
  statusCode,
} from "@/utils/constants";
import WYSiwygEditor from "@/components/common/wysiwygEditor.vue";
import PinIcon from "../svgs/pinIcon.vue";
import PenIcon from "../svgs/penIcon.vue";
import CircularProgressPercent from "../common/circularProgressPercent.vue";
import AssessmentQuestionPrefilledTag from "../assessment/assessmentQuestionPrefilledTag.vue";
import AssessmentQuestionNotApplicableTag from "../assessment/assessmentQuestionNotApplicableTag.vue";
import ExpandingButton from "../common/expandingButton.vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import Button4 from "../common/button4.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { addItemFromMaster } from "@/services/assessment";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { Handler } from "mitt";
import VendorAssessmentQuestionEvaluate from "../vendor/vendorAssessmentQuestionEvaluate.vue";
import StatusBadge from "../common/setting/statusBadge.vue";
import { debounce } from "lodash";

const props = defineProps({
  selectedQuestions: {
    type: Array as () => number[],
    default: () => [],
  },
  checklistItem: {
    type: Object,
    default: () => ({}),
  },
  viewStyle: {
    type: String as PropType<keyof typeof TYPE_ASSESSMENT_VIEW_STYLE>,
    default: TYPE_ASSESSMENT_VIEW_STYLE.user,
  },
  placeholder: {
    type: String,
    default: "",
  },
  isSelectedAll: {
    type: Boolean,
    default: false,
  },
});

let setTimeOutRef: any = null;
const route = useRoute();
const id = Number(route.params.assessmentId);
const onHover: Ref<boolean> = ref(false);
const isCollapsed: Ref<boolean> = ref(true);
const passkeyQuestion: Ref<string> = ref("");
const notesValue = ref(props.checklistItem.checklistItemNotes || "");
let currenNotesValue = props.checklistItem.checklistItemNotes;

const checklistItemDataRaw = computed(() => {
  return props.checklistItem;
});

const isSelected: Ref<boolean> = ref(false);
const isExclude: Ref<boolean> = computed(() => {
  return (
    checklistItemDataRaw.value?.visibleState ===
    assessmentQuestionVisibleState.no
  );
});

const evaluateOptions = computed(() => {
  const data = store.state.Assessment.assessmentQuestionTypes?.find(
    (item) =>
      item.id === checklistItemDataRaw.value?.checklistItemComplianceTypeOrgId,
  );

  if (!data) return [];

  return data.complianceTypeValues;
});

const evaluateAnswer: Ref = ref(
  checklistItemDataRaw.value?.checklistItemComplianceTypeValueOrgId
    ? checklistItemDataRaw.value?.checklistItemComplianceTypeValueOrgId
    : null,
);

const getLabelEvaluateTag = () => {
  const selected = evaluateOptions.value.find(
    (item) => item.id === evaluateAnswer.value,
  );

  return selected?.label;
};

const getValueEvaluateTag = () => {
  const selected = evaluateOptions.value.find(
    (item) => item.id === evaluateAnswer.value,
  );

  if (!selected) return "";
  if (selected?.order === 1) return statusCode.notAccepted;
  if (selected?.order === 2) return statusCode.informationRequired;
  if (selected?.order === 3) return statusCode.accepted;
};

const handleSelectedEvaluateAnswer = (value) => {
  if (value["complianceTypeValueOrgId"])
    evaluateAnswer.value = value["complianceTypeValueOrgId"];
};

const handleFocusoutUpdateNote = debounce(async () => {
  if (notesValue.value === currenNotesValue) return;
  const res = await store.dispatch("Vendor/updateRequestedItems", {
    id: Number(route.params.assessmentId),
    values: [
      {
        notes: notesValue.value,
        checklistRequestedItemId: checklistItemDataRaw.value.checklistItemId,
      },
    ],
  });

  if (!res) {
    notesValue.value = currenNotesValue;
  }
}, 450);

const handleUpdateNote = debounce((value: string) => {
  notesValue.value = value;
}, 450);

const isChecklistCompleted: ComputedRef<boolean> = computed(() => false);
const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;
};
const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
  }, 150);
};
const emits = defineEmits([
  "openEvidenceModal",
  "exclude",
  "update:selected",
  "showModalAddNoteAssessment",
  "uploadFile",
  "showAdvanceModal",
]);
const showAdvanceModal = () => {
  emits("showAdvanceModal", passkeyQuestion.value);
};
onMounted(() => initial());
const initial = () => {
  EventEmitter.on(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, ((data: {
    password: string;
    checklistItemId: number;
  }) => {
    if (
      data.password &&
      data.checklistItemId === checklistItemDataRaw.value.checklistItemId
    ) {
      passkeyQuestion.value = data.password;
    }
  }) as Handler<unknown>);
};
// const addItemAction = async () => {
//   const res = await addItemFromMaster(Number(route.query.checklistId), [
//     checklistItemDataRaw.value.checklistItemId,
//   ]);
//   if (res) {
//     const params = {
//       checklistIdParam: Number(route.query.checklistId),
//       showMasterItem: true,
//     };
//     store.dispatch("Assessment/fetchChecklistByCategory", params);
//   }
// };
const handleSelectedQuestions = () => {
  if (isExclude.value || checklistItemDataRaw.value.checklistItemIsNa) return;
  isSelected.value = !isSelected.value;
  emits("update:selected", {
    isSelected: isSelected.value,
  });
};

watch(
  () => props.isSelectedAll,
  (value) => {
    isSelected.value = value;
  },
);
</script>
<style scoped>
.assessmentQuestion {
  display: flex;
  justify-content: space-between;
  border: 1px solid #eff0f1;
  border-radius: 6px;
  background: #fff;
  width: 100%;
  /* max-width: 1060px; */
  @media (max-width: 1536px) {
    max-width: 100%;
  }
}
.question:hover {
  background: rgba(242, 248, 255, 0.5);
}
.bgGrey {
  background: #fcfcfd !important;
  border: 1px solid #eff0f1 !important;
}
.level2Bg {
  border: 1px solid #eff0f1 !important;
  background: #fff !important;
}
.questionWrapper > * {
  transition: opacity 0.3s ease-in-out;
}
.collapsed {
  opacity: 0;
  height: 0;
  overflow: hidden;
}
.open {
  opacity: 1;
  height: auto;
}
.greyed {
  opacity: 0.5 !important;
}
.disabled {
  pointer-events: none;
  background-color: #62a2f5;
  color: #666666;
}
button:hover {
  cursor: pointer;
  color: #387dff;
}
button {
  border: 1.5px solid var(--ui-rule, #eff0f1);
  background: var(--ui-white, #fff);
}
.text-with-icon {
  display: flex;
  align-items: center;
  margin: 0;
}
.info-icon {
  margin-left: 5px;
  vertical-align: middle;
}
</style>
